import { createFileRoute } from "@tanstack/react-router"
import { organizationDocumentDetailsViewLayoutHandle } from "src/views/OrganizationDocumentDetailsView/constants"
import { OrganizationDocumentDetailsView } from "src/views/OrganizationDocumentDetailsView/OrganizationDocumentDetailsView"

export const Route = createFileRoute("/_loggedIn/$organizationId/_map/_layout/documents/$documentId")({
	component: OrganizationDocumentDetailsView,
	staticData: organizationDocumentDetailsViewLayoutHandle,
})
